var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['flash-message', `--is-${_vm.type}`]},[(_vm.type === 'warning')?_c('i',{staticClass:"icon icon-exclamation-circle"}):(_vm.type === 'error')?_c('i',{staticClass:"icon icon-times"}):_c('i',{staticClass:"icon icon-info-circle"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }